import { render } from "./big-logo-letter.svg?vue&type=template&id=2eedfcd3&inline"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__